// removed by extract-text-webpack-plugin
module.exports = {"sk-wave":"qempo_3-wave_sk-wave-14LgQ_t","sk-rect":"qempo_3-wave_sk-rect-3YKUUpL","sk-waveStretchDelay":"qempo_3-wave_sk-waveStretchDelay-3FgK3wP","sk-rect1":"qempo_3-wave_sk-rect1-3CNVRM_","sk-rect2":"qempo_3-wave_sk-rect2-1vcoOJs","sk-rect3":"qempo_3-wave_sk-rect3-1SJf_ot","sk-rect4":"qempo_3-wave_sk-rect4-ls2pFF5","sk-rect5":"qempo_3-wave_sk-rect5-VJcnO0n"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/spinkit/scss/spinners/3-wave.scss
// module id = 1264
// module chunks = 0